export default __webpack_public_path__ + "static/media/banner_bronze.255a2456.png";